import states from '../../shared/states/usStates.json';

const nameToCode = new Map(
  states.map((entry) => [entry.name.toLowerCase(), entry.code]),
);
const codeSet = new Set(states.map((entry) => entry.code));

/**
 * Normalizes a state value to a 2-letter US state code, or null when empty/unknown.
 */
export function normalizeState(rawState) {
  const trimmed = typeof rawState === 'string' ? rawState.trim() : '';
  if (!trimmed) {
    return { code: null, error: 'State is required' };
  }

  const upper = trimmed.toUpperCase();
  if (codeSet.has(upper)) {
    return { code: upper, error: null };
  }

  const fromName = nameToCode.get(trimmed.toLowerCase());
  if (fromName) {
    return { code: fromName, error: null };
  }

  return { code: null, error: `Unknown state "${trimmed}"` };
}
